<div mat-dialog-content style="width: 500px">
    <h5 class="title text-center">Defina o tempo para finalização</h5>
    <div class="col-12 mt-2 mb-2">

        <mat-form-field>
            <mat-select [(ngModel)]="minutes">
                    <mat-option [value]="10">10 minutos</mat-option>
                    <mat-option [value]="60">1 hora</mat-option>
                    <mat-option [value]="1440">24 horas</mat-option>
            </mat-select>
        </mat-form-field>
        <button class="btn btn-primary btn-rounded btn-block" (click)="onClickConfirm()">
            <span>
              CONFIRMAR
            </span>
          </button>
        <button class="btn btn-transparent btn-rounded btn-block"
            (click)="onNoClick()">CANCELAR</button>
    </div>
</div>